<template>
  <div class="wrap" style="overflow: hidden">
    <yd-backtop></yd-backtop>
    <div class="content">
      <yd-navbar title="待用印列表">
        <router-link :to="{path: $route.fullPath}" slot="left">
          <yd-button type="hollow">{{orderDate}}</yd-button>
        </router-link>

        <router-link to="msoList" slot="right">
          <yd-navbar-next-icon>用印记录</yd-navbar-next-icon>
        </router-link>
      </yd-navbar>
      <!-- <yd-search v-model="value1" :on-submit="submitHandler" placeholder="输入合同编号或供应商名称进行搜索"></yd-search> -->
      <yd-tab v-model="tabSign" :prevent-default="false" :item-click="itemClick" bg-color="#ecf5ff" active-color="green" horizontal-scroll="false">
        <yd-tab-panel v-for="(list,key) in contractList" :key="key" :label="list.period" :badge="list.signList.length" badge-bgcolor="#409eff" badge-scale="1">
          <yd-preview :buttons="btns" class="nobtn" v-for="(item,index) in list.signList" :key="index">
            <yd-preview-header style="margin-top:10px">
              <div slot="left" style="color:#000;text-align: start;">顺序号：<yd-badge type="primary">{{item.apply_no}}</yd-badge></div>
              <div slot="right">
                <yd-badge shape="square" type="warning">待用印</yd-badge>
              </div>
            </yd-preview-header>
<!--            <yd-preview-item>-->
<!--              <div slot="left">合同名称</div>-->
<!--              <div slot="right">{{item.contract_name}}</div>-->
<!--            </yd-preview-item>-->
            <yd-preview-item>
              <div slot="left">供应商编码</div>
              <div slot="right">{{item.supplier_no}}</div>
            </yd-preview-item>
            <yd-preview-item>
              <div slot="left">供应商名称</div>
              <div slot="right">{{item.supplier_name}}</div>
            </yd-preview-item>
            <yd-preview-item>
              <div slot="left">报审序号</div>
              <div slot="right">{{item.contract_no_area}}</div>
            </yd-preview-item>
            <yd-preview-item>
              <div slot="left"><yd-button type="primary" @click.native="enterSign(item.id)" bgcolor="#2f6fff" color="#fff">确认用印</yd-button>
              </div>
              <div slot="right"> <yd-button type="danger" @click.native="backOrder(item.id)">退回重约</yd-button></div>
            </yd-preview-item>
          </yd-preview>
          <yd-preview style="padding: 20px;font-size: 14px;" :buttons="btnsEmpty" class="nobtn" v-if="list.signList.length==0">{{list.content}}</yd-preview>
        </yd-tab-panel>
      </yd-tab>
    </div>
    <yd-popup v-model="showBack" position="center" width="80%">
      <div style="background-color:#fff;">
        <yd-cell-group title="请输入退回原因">
          <yd-cell-item>
            <yd-textarea v-model="backReason" slot="right" placeholder="在此输入退回原因" minlength="3" maxlength="200"></yd-textarea>
          </yd-cell-item>
        </yd-cell-group>
        <p style="text-align: center;">
          <yd-button size="large" @click.native="exeBack" bgcolor="#2f6fff" color="#fff">确认退回</yd-button>
        </p>
      </div>
    </yd-popup>
  </div>

</template>

<script>
import axios from "axios";
var baseUrl = process.env.API_ROOT;
export default {
  name: "msoIndex",
  data() {
    return {
      signCode:'',
      showBack:false,
      backOrderId:'',
      backReason:'',
      tabSign:0,
      orderDate:'',
      btnsEmpty:[],
      btns:[],
      contractList: [],
      userId: window.localStorage.getItem("checkUserId")
    };
  },
  methods: {
    itemClick(key) {
        this.$dialog.loading.open('数据加载中');
        this.tabSign = key;
        this.$dialog.loading.close();
    },
    signList() {
      this.$router.push({ path: "msoList" });
    },
    //加载已核销合同资源
   //梁新2023-03-29
    getSignList(userId){
      axios({
          method: "get",
          url: baseUrl + "todoSign?userId="+userId
        }).then(resp => {
          if (resp.data.error_code == "0") {
            this.contractList = resp.data.data
            this.orderDate = resp.data.orderDate
          }
          })
    },
    enterSign(orderId){
      axios({
          method: "post",
          url: baseUrl + "signEnter",
            params:{
                code:orderId,
                signUser:this.userId
            }
        }).then(resp => {
          if(resp.data.result==="false") {
              this.$dialog.toast({ mes: resp.data.message, timeout: 1500 });
            }else{
              this.$dialog.toast({ mes: resp.data.message, timeout: 1500 });
              this.getSignList(this.userId);
            }
          })
    },
    backOrder(orderId){
      this.showBack = true
      this.backOrderId = orderId
    },
    exeBack(){
      if(this.backReason && this.backReason.length>=3){
         axios({
          method: "post",
          url: baseUrl + "backOrder",
          params:{
                orderId:this.backOrderId,
                userId:this.userId
            }
        }).then(resp => {
           if(resp.data.result==="true") {
              this.$dialog.toast({
                    mes: '退回成功',
                    timeout: 1500,
                    icon: 'success'
                });
                this.showBack = false
                this.getSignList(this.userId);

          }
          })
      }else{
 this.$dialog.toast({ mes: '至少输入3个字以上的退回原因', timeout: 1500 });
        return
      }

    },
    scanQr() {
      axios({
        method: "get",
        url: baseUrl + "scannerQrcode?username=" + this.checkUserId
      }).then(resp => {
        if (resp.data.error_code == "0") {
          let data = resp.data.data;
          let that = this
          wx.config({
            debug: false,
            appId: data.appId, // 必填,公众号的唯一标识
            timestamp: data.timestamp, // 必填,生成签名的时间戳
            nonceStr: data.nonceStr, // 必填,生成签名的随机串
            signature: data.signature, // 必填,签名
            jsApiList: ["scanQRCode", "checkJsApi"] // 必填,需要使用的JS接口列表
          });
          wx.ready(function() {
            // config信息验证成功后会执行ready方法,所有接口调用都必须在config接口获得结果之后
            // config 是一个客户端的异步操作,所以如果需要在页面加载时调用相关接口,则须把相关接口放在ready函数中调用来确保正确执行.对于用户触发是才调用的接口,则可以直接调用,不需要放在ready函数中
            wx.checkJsApi({
              // 判断当前客户端版本是否支持指定JS接口
              jsApiList: ["scanQRCode"],
              success: function(res) {
                // 以键值对的形式返回，可用true，不可用false。如：{"checkResult":{"scanQRCode":true},"errMsg":"checkJsApi:ok"}
                if (res.checkResult.scanQRCode === true) {
                  wx.scanQRCode({
                    // 微信扫一扫接口
                    desc: "scanQRCode desc",
                    needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
                    scanType: ["qrCode", "barCode"], // 可以指定扫二维码还是一维码，默认二者都有
                    success: function(res) {
                      that.toSign(res.resultStr)
                    }
                  });
                } else {
                  alert("抱歉，当前客户端版本不支持扫一扫");
                }
              },
              fail: function(res) {
                // 检测getNetworkType该功能失败时处理
                alert("抱歉，当前客户端版本不支持扫一扫");
              }
            });
          });
        }else{
           alert(resp.data.error_msg)
        }
      });
    },
    toSign(code){
   this.$router.push({path:"/msoSign",query:{code:code}});
    }
  },
  mounted() {
    if (this.userId == "" || this.userId == undefined) {
      //转向登录页面
      this.$router.push({ path: "/login" });
    }
    this.getSignList(this.userId);
  }
};
</script>

<style scoped>
.wrap /deep/ .yd-tab-nav .yd-tab-active {
  color: rgba(47, 111, 255, 1) !important;
}
.yd-preview-header > :last-child {
  font-size: 0.28rem;
  margin-right: 0.2rem;
}
/deep/ .yd-tab-nav-item {
  margin: 0px 10px;
}
/deep/ .yd-tab-nav-scoll .yd-tab-nav .yd-tab-nav-item {
  padding: 0 10px !important;
}
/deep/ .yd-tab-nav {
  width: fit-content !important;
}
/deep/ .yd-tab-nav .yd-tab-active {
  font-weight: bolder;
}

/deep/ .yd-preview-footer {
  font-weight: bolder;
}

/deep/ .yd-preview-footer a:first-child {
  background: #ecf5ff;
}
/deep/ .yd-preview-footer a:last-child {
  background: #ffebeb;
}
/deep/ .yd-preview-footer {
  height: 0.7rem;
}
</style>



// WEBPACK FOOTER //
// src/components/mso-index.vue